import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";

const SearchFilterFormData = {
    name: "Search Filter Form Data",
    initialState: {
        ProjectTypeId: null,
    },
    section: [
        {
          title: "Search Filter Form Data",
          row: {},
          style: {
            sectionStyle: "row verticle-form",
          },
          rowGroup: [
            {
              groupLabel: "Search Filter Form Data", // Group for contact fields
              style: {
                groupStyle: "col-lg-12 col-md-12 mb-2",
              },
              groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
              fields: [

                {
                  id: "ProjectTypeId",
                  label: "Project",
                  Field_Name: "Project",
                  fieldType: FormFieldTypes.SELECT,
                  dataField: "ProjectTypeId",
                  fieldSetting: {
                    placeholder: "Select",
                    options: [],
                  },
                  style: {
                    containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
                  },
                },
              ],
            },
          ],
        },
      ],
    
}

export default SearchFilterFormData;